// extracted by css-extract-rspack-plugin
export default {"cls1":"Comments-cls1_DPC","cls2":"Comments-cls2_ycV Comments-cls1_DPC"};